import React, { useState, useRef } from 'react';
import { ChevronLeft, ChevronRight, Volume2, VolumeX } from 'lucide-react';

const slides = [
  {
    id: 1, type: 'title',
    title: "Les Lois et Textes de Référence",
    subtitle: "DEEJE - Cadre réglementaire de l'accueil du jeune enfant"
  },
  {
    id: 2, type: 'law',
    title: "LE DÉCRET DE 2010",
    label: "DÉCRET DE JUIN 2010",
    description: "Le Décret n° 2010-613 du 7 juin 2010 relatif aux établissements et services d'accueil des enfants de moins de six ans.",
    color: "#1E40AF",
    link: "/documents/lois/Decret-aout-2010.pdf"
  },
  {
    id: 3, type: 'law',
    title: "LE DÉCRET DE 2007",
    label: "DÉCRET DE FÉVRIER 2007",
    description: "Le Décret n° 2007-230 du 20 février 2007 relatif aux établissements et services d'accueil des enfants de moins de six ans et modifiant le code de la santé publique.",
    color: "#7C3AED",
    link: "/documents/lois/decret-2007.pdf"
  },
  {
    id: 4, type: 'law',
    title: "LE DÉCRET DE 2000",
    label: "DÉCRET D'AOÛT 2000",
    description: "Le Décret n° 2000-762 du 1 août 2000 relatif aux établissements et services d'accueil des enfants de moins de six ans et modifiant le code de la santé publique.",
    color: "#059669",
    link: "https://www.legifrance.gouv.fr/jorf/id/JORFTEXT000000218271/"
  },
  {
    id: 5, type: 'law',
    title: "La charte nationale pour l'accueil du jeune enfant",
    label: "Cadre national Accueil enfant",
    description: "Le texte-cadre national destiné à forger une identité commune à l'ensemble des professionnels de la petite enfance.",
    color: "#D97706",
    link: "/documents/lois/charte-nationale-accueil-jeune-enfant.pdf"
  },
  {
    id: 6, type: 'law',
    title: "LE RAPPORT DES 1000 PREMIERS JOURS",
    label: "RAPPORT DES 1000 PREMIERS JOURS",
    description: "La préparation du parcours 1000 jours s'appuie sur une commission de 18 experts, présidée par le neuropsychiatre Boris Cyrulnik. Elle regroupe des experts de spécialités différentes avec une conviction commune : l'importance décisive des 1000 premiers jours de l'enfant. Ils et elles sont neuropsychiatres, spécialistes de l'éducation ou de l'éveil des enfants, acteurs de terrain de l'accompagnement social des parents, pédiatres et praticiens hospitaliers, sage-femme.",
    color: "#E75480",
    link: "/documents/lois/rapport-1000-premiers-jours.pdf"
  },
  {
    id: 7, type: 'law',
    title: "La Loi ASAP",
    label: "LOI ASAP",
    description: "Les textes qui régissent aujourd'hui les modes d'accueil du jeune enfant sont complexes, et source d'incompréhension et de difficultés pour les parents comme les professionnels du secteur. Le Gouvernement présente les principales mesures d'une réforme prévue dans le cadre de la loi d'Accélération et de Simplification de l'Action Publique, dite « ASAP ». Cette réforme constitue le volet « modes d'accueil » de la démarche des « 1 000 premiers jours », qui entend concentrer l'attention et les moyens sur cette période fondatrice pour l'enfant.",
    color: "#0891B2",
    link: "/documents/lois/loi-asap.pdf"
  },
  {
    id: 8, type: 'law',
    title: "LE CODE DE LA SANTÉ PUBLIQUE",
    label: "Code de la Santé Publique",
    description: "Les articles R2324-16 et R2324-17 définissent les missions confiées aux EAJE.\nLes articles R2324-18 à R2324-24 définissent les modalités de création, d'extension et de transformation des EAJE.\nLes articles R2324-25 à R2324-32 définissent l'organisation et le fonctionnement des EAJE.\nLes articles R2324-33 à R2324-45 définissent la composition du personnel encadrant.\nLes articles R2324-46 et R2324-48 définissent les dispositions particulières et dérogatoires.",
    color: "#1E40AF",
    link: "https://www.legifrance.gouv.fr/codes/texte_lc/LEGITEXT000006072665/"
  },
  {
    id: 9, type: 'law',
    title: "Le RAPPORT GIAMPINO",
    label: "RAPPORT GIAMPINO",
    description: "Le rapport de Sylviane Giampino fait suite aux débats menés par la mission constituée autour de l'accueil des enfants de moins de 3 ans. Et le constat dressé par cette mission est celui d'un lien insuffisant entre le monde de la recherche, l'univers institutionnel et la réalité quotidienne des modes d'accueil.",
    color: "#7C3AED",
    link: "/documents/lois/rapport-giampino.pdf"
  },
  {
    id: 10, type: 'law',
    title: "La SYNTHÈSE DU RAPPORT GIAMPINO",
    label: "SYNTHÈSE GIAMPINO",
    description: "Le rapport répond à 3 problématiques :\n- Établir une synthèse partagée du dernier état des connaissances quant au développement du jeune enfant\n- Tirer les enseignements dans les domaines du lien avec les familles, de l'organisation des modes d'accueil, et de la formation des professionnels\n- Proposer à chaque pas une préconisation dont le caractère concret et l'applicabilité rapide sont les garants que le travail de réflexion mené aura des conséquences pratiques.",
    color: "#059669"
  },
  {
    id: 11, type: 'law',
    title: "Le Décret d'août 2021 : réforme des modes d'accueil",
    label: "Décret août 2021",
    description: "Décret n°2021-1131 du 30 août 2021 relatif aux assistants maternels et aux établissements d'accueil de jeunes enfants. Il concerne la réforme des modes d'accueil, en application de l'ordonnance du 19 mai 2021 relative aux services aux familles.",
    color: "#D97706",
    link: "/documents/lois/decret-2021.pdf"
  },
  {
    id: 12, type: 'law',
    title: "Le Décret de novembre 2017 : organisation de visite en présence d'un tiers",
    label: "Décret novembre 2017",
    description: "Le décret du 15 novembre 2017, article 375-7 du code civil, apporte un cadre aux visites en présence d'un tiers. Il vient préciser leurs modalités d'organisation et le fonctionnement des espaces de rencontre entre enfants et parents, ainsi que le statut et le rôle du tiers professionnel.",
    color: "#E75480",
    link: "/documents/lois/decret-2017.pdf"
  },
  {
    id: 13, type: 'law',
    title: "Le Code de l'Action Sociale et des Familles",
    label: "CASF",
    description: "Ce code organise pour une grande part la solidarité républicaine en direction de l'ensemble des familles, quelles qu'en soient leur situation et composition.",
    color: "#0891B2",
    link: "/documents/lois/code-action-sociale-familles.pdf"
  },
  {
    id: 14, type: 'law',
    title: "La Convention Internationale des Droits de l'Enfant",
    label: "CIDE",
    description: "Parce que les enfants sont plus vulnérables que les adultes, parce qu'ils n'ont ni droit de vote ni influence politique ou économique, parce que le développement sain des enfants est crucial pour l'avenir de toute société, le monde s'est doté en 1989 de la Convention internationale des droits de l'enfant (CIDE). Depuis, ce traité fondamental est le socle de toute l'action d'UNICEF.",
    color: "#1E40AF",
    link: "/documents/lois/convention-droits-enfant.pdf"
  },
  {
    id: 15, type: 'law',
    title: "La Loi de 2002 relative à l'autorité parentale",
    label: "Loi de 2002",
    description: "La loi n°2002-305 du 4 mars 2002 a remanié l'article 371-1 du Code civil en disposant que \"L'autorité parentale est un ensemble de droits et de devoirs ayant pour finalité l'intérêt de l'enfant\".",
    color: "#7C3AED",
    link: "/documents/lois/loi-2002-autorite-parentale.pdf"
  },
  {
    id: 16, type: 'law',
    title: "Le Décret de juillet 2021",
    label: "Observatoire National de la protection de l'enfance",
    description: "Décret n°2021-929 du 12 juillet 2021 fixant les modalités de transmission d'informations par le ministère de la justice à l'Observatoire national de la protection de l'enfance.",
    color: "#059669",
    link: "https://www.legifrance.gouv.fr/loda/id/JORFTEXT000000776352/"
  },
  {
    id: 17, type: 'law',
    title: "La Loi d'orientation de juillet 1998",
    label: "Loi d'orientation",
    description: "Loi n°98-657 du 29 juillet 1998 d'orientation relative à la lutte contre les exclusions. Cette loi présente deux orientations fondamentales : Un traitement des exclusions ; L'accès aux droits fondamentaux.",
    color: "#D97706",
    link: "/documents/lois/loi-1998.pdf"
  },
  {
    id: 18, type: 'law',
    title: "La loi de 2002 rénovant l'action sociale",
    label: "Loi 2002 AS et MS",
    description: "La loi n°2002-2 du 2 janvier 2002 rénovant l'action sociale et médico-sociale fixe de nouvelles règles relatives aux droits des personnes.",
    color: "#E75480",
    link: "https://www.legifrance.gouv.fr/jorf/id/JORFTEXT000000215460/"
  },
  {
    id: 19, type: 'law',
    title: "La Loi de 2016 concernant la protection de l'enfant",
    label: "Loi protection de l'enfant",
    description: "La loi n° 2016-297 relative à la protection de l'enfant, issue d'une proposition de loi déposée au Sénat le 12 septembre 2014 a été promulguée le 14 mars 2016 et publiée au journal officiel le 15 mars 2016. Elle vise à modifier et compléter la loi n° 2007-293 du 5 mars 2007 réformant la protection de l'enfance.",
    color: "#0891B2",
    link: "https://www.legifrance.gouv.fr/jorf/id/JORFTEXT000000215460/"
  },
  {
    id: 20, type: 'law',
    title: "La circulaire CAF",
    label: "Circulaire CAF",
    description: "Accompagnement par les Caf des établissements d'accueil du jeune enfant et des maisons d'assistants maternels durant la crise sanitaire Covid19 – mise à jour juillet 2021.",
    color: "#1E40AF",
    link: "/documents/lois/circulaire-caf.pdf"
  },
  {
    id: 21, type: 'law',
    title: "Le rapport Terra Nova",
    label: "Rapport Terra Nova",
    description: "La lutte contre les inégalités commence dans les crèches : investir dans la petite enfance, et égalité des chances.",
    color: "#7C3AED",
    link: "https://www.legifrance.gouv.fr/jorf/id/JORFTEXT000000215460/"
  },
  {
    id: 22, type: 'law',
    title: "La nouvelle Charte nationale pour l'accueil du jeune enfant",
    label: "Charte Nationale",
    description: "Arrêté du 23 septembre 2021 portant création d'une charte nationale pour l'accueil du jeune enfant, basée sur le rapport des 1000 premiers jours.",
    color: "#059669",
    link: "/documents/lois/charte-nationale-2021.pdf",
    image: "/images/charte-nationale-jeune-enfant.png"
  },
  {
    id: 23, type: 'title',
    title: "Bravo !",
    subtitle: "Les lois et décrets n'ont plus de secret pour vous ! Vous maîtrisez désormais le cadre réglementaire essentiel pour votre DEEJE."
  }
];

function TitleSlide({ slide }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '400px', textAlign: 'center', padding: '2rem' }}>
      <div style={{ fontSize: '3rem', marginBottom: '1.5rem' }}>
        <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#1E40AF" strokeWidth="1.5"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>
      </div>
      <h1 style={{ fontSize: '2rem', fontWeight: 'bold', color: '#1E40AF', marginBottom: '1rem' }}>{slide.title}</h1>
      <p style={{ fontSize: '1.1rem', color: '#6B7280', maxWidth: '600px' }}>{slide.subtitle}</p>
      <div style={{ marginTop: '2rem', padding: '0.5rem 1.5rem', background: '#EEF2FF', borderRadius: '2rem', color: '#4F46E5', fontWeight: '600', fontSize: '0.9rem' }}>
        {slides.filter(s => s.type === 'law').length} textes de référence
      </div>
    </div>
  );
}

function LawSlide({ slide }) {
  return (
    <div style={{ padding: '2rem', minHeight: '400px', display: 'flex', flexDirection: 'column' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
        <div style={{ width: '6px', height: '60px', background: slide.color, borderRadius: '3px', flexShrink: 0 }} />
        <div>
          <span style={{ fontSize: '0.75rem', fontWeight: '700', color: slide.color, textTransform: 'uppercase', letterSpacing: '0.05em' }}>{slide.label}</span>
          <h2 style={{ fontSize: '1.4rem', fontWeight: 'bold', color: '#1F2937', marginTop: '0.25rem' }}>{slide.title}</h2>
        </div>
      </div>
      <div style={{ flex: 1, background: '#F9FAFB', borderRadius: '1rem', padding: '1.5rem', border: `1px solid ${slide.color}20` }}>
        {slide.image && (
          <img src={slide.image} alt={slide.title} style={{ width: '100%', maxHeight: '250px', objectFit: 'contain', borderRadius: '0.5rem', marginBottom: '1rem' }} />
        )}
        {slide.description.split('\n').map((line, i) => (
          <p key={i} style={{ fontSize: '1rem', lineHeight: '1.7', color: '#374151', marginBottom: line.startsWith('-') ? '0.5rem' : '0.75rem' }}>
            {line}
          </p>
        ))}
        {slide.link && (
          <a href={slide.link} target="_blank" rel="noopener noreferrer" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', marginTop: '0.5rem', color: slide.color, fontWeight: '600', fontSize: '0.9rem', textDecoration: 'none' }}>
            Consulter le texte officiel &rarr;
          </a>
        )}
      </div>
    </div>
  );
}

function InfoSlide({ slide }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '400px', textAlign: 'center', padding: '2rem' }}>
      <div style={{ background: '#F0FDF4', borderRadius: '1rem', padding: '2rem 3rem', border: '1px solid #BBF7D0' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#166534', marginBottom: '1rem' }}>{slide.title}</h2>
        <p style={{ fontSize: '1.1rem', color: '#374151' }}>{slide.description}</p>
      </div>
    </div>
  );
}

export default function DEEJELoisPresentation() {
  const [current, setCurrent] = useState(0);
  const [speaking, setSpeaking] = useState(false);
  const synthRef = useRef(window.speechSynthesis);

  const slide = slides[current];

  const speak = (text) => {
    synthRef.current.cancel();
    const u = new SpeechSynthesisUtterance(text);
    u.lang = 'fr-FR'; u.rate = 0.9;
    u.onend = () => setSpeaking(false);
    setSpeaking(true);
    synthRef.current.speak(u);
  };

  const stopSpeak = () => { synthRef.current.cancel(); setSpeaking(false); };

  const readSlide = () => {
    if (speaking) { stopSpeak(); return; }
    if (slide.type === 'law') speak(`${slide.title}. ${slide.description}`);
    else if (slide.type === 'title') speak(`${slide.title}. ${slide.subtitle}`);
    else if (slide.type === 'info') speak(`${slide.title}. ${slide.description}`);
  };

  const prev = () => { stopSpeak(); setCurrent(c => Math.max(0, c - 1)); };
  const next = () => { stopSpeak(); setCurrent(c => Math.min(slides.length - 1, c + 1)); };

  return (
    <div style={{ maxWidth: '900px', margin: '0 auto' }}>
      <div style={{ background: 'white', borderRadius: '1rem', boxShadow: '0 4px 24px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
        <div style={{ background: 'linear-gradient(135deg, #1E40AF 0%, #3B82F6 100%)', padding: '0.75rem 1.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: 'white' }}>
          <span style={{ fontWeight: '600', fontSize: '0.9rem' }}>Lois et Textes de Référence</span>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <button onClick={readSlide} style={{ background: 'rgba(255,255,255,0.2)', border: 'none', borderRadius: '50%', width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: 'white' }}>
              {speaking ? <VolumeX size={18} /> : <Volume2 size={18} />}
            </button>
            <span style={{ fontSize: '0.85rem' }}>{current + 1} / {slides.length}</span>
          </div>
        </div>

        {slide.type === 'title' && <TitleSlide slide={slide} />}
        {slide.type === 'law' && <LawSlide slide={slide} />}
        {slide.type === 'info' && <InfoSlide slide={slide} />}

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 1.5rem', borderTop: '1px solid #E5E7EB' }}>
          <button onClick={prev} disabled={current === 0} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.5rem 1rem', borderRadius: '0.5rem', border: '1px solid #D1D5DB', background: 'white', cursor: current === 0 ? 'not-allowed' : 'pointer', opacity: current === 0 ? 0.4 : 1, fontSize: '0.9rem', color: '#374151' }}>
            <ChevronLeft size={18} /> Précédent
          </button>
          <div style={{ display: 'flex', gap: '4px' }}>
            {slides.map((_, i) => (
              <div key={i} onClick={() => { stopSpeak(); setCurrent(i); }} style={{ width: i === current ? '24px' : '8px', height: '8px', borderRadius: '4px', background: i === current ? '#1E40AF' : '#D1D5DB', cursor: 'pointer', transition: 'all 0.2s' }} />
            ))}
          </div>
          <button onClick={next} disabled={current === slides.length - 1} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.5rem 1rem', borderRadius: '0.5rem', border: 'none', background: current === slides.length - 1 ? '#D1D5DB' : '#1E40AF', color: 'white', cursor: current === slides.length - 1 ? 'not-allowed' : 'pointer', fontSize: '0.9rem' }}>
            Suivant <ChevronRight size={18} />
          </button>
        </div>
      </div>
    </div>
  );
}
